var render = function render(){var _vm=this,_c=_vm._self._c;return _c('baidu-map',{staticStyle:{"height":"60vh","width":"100%"},attrs:{"zoom":_vm.zoom,"center":_vm.center,"scroll-wheel-zoom":true,"double-click-zoom":false},on:{"ready":_vm.initMap}},[_c('bm-navigation',{attrs:{"anchor":"BMAP_ANCHOR_TOP_RIGHT"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }